/**
 * Helpers for hex colour inputs that show a permanent, non-editable "#" prefix.
 * The editable text holds only the digits, so a user can paste a bare "ffffff"
 * (or a full "#ffffff") and land on the same stored "#ffffff".
 */

/** Strip any leading "#" so the editable text shows the digits only. */
export const stripHash = (v?: string | null): string => (v ?? "").replace(/^#+/, "");

/**
 * Normalise user input (which may include a pasted "#") to a single "#RRGGBB".
 * Empty input stays empty so "unset" semantics are preserved.
 */
export const withHash = (v: string): string => {
  const digits = v.replace(/^#+/, "");
  return digits === "" ? "" : `#${digits}`;
};
